// extracted by mini-css-extract-plugin
export default {"mainContainer":"Contact_mainContainer__zaolW","contactCard":"Contact_contactCard__0C5z+"};